const waitForController = () =>
  new Promise<void>((resolve, reject) => {
    if (navigator.serviceWorker.controller) {
      resolve();
      return;
    }

    const timeout = window.setTimeout(() => {
      navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
      reject(new Error("The payment return handler could not be activated. Refresh and try again."));
    }, 10000);
    const onControllerChange = () => {
      window.clearTimeout(timeout);
      navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
      resolve();
    };
    navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);
  });

export async function ensureMFPostbackBridge() {
  if (!("serviceWorker" in navigator)) {
    throw new Error("This browser cannot safely handle the bank payment return.");
  }
  const registration = await navigator.serviceWorker.register("/mf-postback-sw.js", {
    scope: "/",
  });
  await navigator.serviceWorker.ready;
  if (!registration.active && !navigator.serviceWorker.controller) {
    await waitForController();
  } else if (!navigator.serviceWorker.controller) {
    await waitForController();
  }
}
